import React, { useState } from "react";

// exported so CookieManager can see the keys
export const COOKIE_CATEGORIES = [
  {
    key: "functional",
    label: "Functional",
    description:
      "To monitor the performance of our site and to enhance your browsing experience. For example, these tools enable you to communicate with us via live chat.",
    required: true,
  },
  {
    key: "analytics",
    label: "Analytics",
    description:
      "To help us understand how our site is used (e.g. page views, time on site), so we can improve content and layout.",
  },
  {
    key: "marketing",
    label: "Marketing",
    description:
      "To personalize ads and measure their effectiveness, so we show you more relevant offers.",
  },
];

const STORAGE_KEY = "cookie-preferences";

export default function CookiePreferencesModal({ open, onClose, onSave }) {
  const [prefs, setPrefs] = useState(() =>
    COOKIE_CATEGORIES.reduce((acc, cat) => {
      acc[cat.key] = cat.required || false;
      return acc;
    }, {})
  );

  const toggle = (key) => setPrefs((p) => ({ ...p, [key]: !p[key] }));

  const save = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    if (onSave) onSave();
    else onClose();
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 text-primary"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-lg w-full max-w-xl overflow-hidden shadow-lg">
        <header className="flex items-center justify-between p-4 border-b">
          <h2 className="text-xl font-bold">My preferences</h2>
          <button
            onClick={onClose}
            aria-label="Close preferences"
            className="text-2xl leading-none"
          >
            ×
          </button>
        </header>

        <div className="max-h-80 overflow-y-auto p-4 space-y-4">
          {COOKIE_CATEGORIES.map(({ key, label, description, required }) => (
            <div key={key} className="flex items-start space-x-3">
              <input
                type="checkbox"
                checked={prefs[key]}
                onChange={() => toggle(key)}
                disabled={required}
                className="mt-1 h-5 w-5 text-primary border-gray-300 rounded"
              />
              <div>
                <label className="font-medium">{label}</label>
                <p className="mt-1 text-sm text-gray-600">{description}</p>
              </div>
            </div>
          ))}
        </div>

        <footer className="p-4 border-t">
          <button
            onClick={save}
            className="w-full bg-primary text-white py-3 rounded-lg font-semibold hover:bg-primary/90 transition"
          >
            Save preferences
          </button>
        </footer>
      </div>
    </div>
  );
}
